// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"CopyUserPermissionsMultiSitesForm__wrapper__dAhQy","submitResult":"CopyUserPermissionsMultiSitesForm__submitResult__R0Kar","actionWrapper":"CopyUserPermissionsMultiSitesForm__actionWrapper__1jeg0","wrapper2faOptions":"CopyUserPermissionsMultiSitesForm__wrapper2faOptions__2sleC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CopyUserPermissionsMultiSitesForm/CopyUserPermissionsMultiSitesForm.css
// module id = 2939
// module chunks = 0